import { useId } from 'react'

/** Two-leaf mark from the supplied Final Leaves prototype; decorative beside the Afra name. */
export function AfraMark({ className = '' }: { className?: string }) {
  const id = useId().replace(/:/g, '')
  return <svg className={`afra-mark ${className}`} viewBox="0 0 72 72" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={`${id}-dark`} x1="0" y1="1" x2="1" y2="0">
        <stop stopColor="var(--leaf-dark)" /><stop offset="1" stopColor="var(--leaf-green)" />
      </linearGradient>
      <linearGradient id={`${id}-light`} x1="0" y1="1" x2="1" y2="0">
        <stop stopColor="var(--leaf-light)" /><stop offset="1" stopColor="var(--leaf-pale)" />
      </linearGradient>
    </defs>
    <path d="M34 63 C23 36 36 10 65 5 C68 36 54 57 34 63Z" fill={`url(#${id}-dark)`} />
    <path d="M34 63 C19 57 15 43 19 29 C22 20 26 17 29 15 C41 28 44 44 34 63Z" fill={`url(#${id}-light)`} transform="rotate(-30 31 40) translate(3 5)" />
    <path d="M34 63 C29 54 29 45 33 38 C40 45 40 54 34 63Z" fill="var(--leaf-mid)" opacity=".8" />
  </svg>
}
